var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-group"},[_c('label',{staticClass:"az_base_lbl",class:_vm.labelClass},[_vm._v(_vm._s(_vm.$t('phoneNumber')))]),_c('the-mask',_vm._b({staticClass:"form-control az_base_inp",class:[{'ftr': _vm.isFilter}, _vm.inputClass],model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},'the-mask',{
				'mask': '+### (##) ###-##-##',
				'placeholder': '+### (##) ###-##-##',
				..._vm.$attrs
			},false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }